import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function FSorteos() {
    const [sorteos, setSorteos] = useState([]);
    const [sorteosFiltrados, setSorteosFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [formulario, setFormulario] = useState({
        idSorteo: '',
        nomSorteo: ''
    });
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    const API_URL = '/api/sorteos';

    useEffect(() => {
        cargarSorteos();
    }, []);

    useEffect(() => {
        filtrarSorteos();
    }, [busqueda, sorteos]);

    const cargarSorteos = async () => {
        try {
            const response = await axios.get(API_URL);
            setSorteos(response.data);
            setSorteosFiltrados(response.data);
        } catch (error) {
            console.error('Error al cargar sorteos:', error);
            alert('Error al cargar los sorteos');
        }
    };

    const filtrarSorteos = () => {
        if (!busqueda) {
            setSorteosFiltrados(sorteos);
            setPaginaActual(1);
            return;
        }

        const filtrados = sorteos.filter(sorteo =>
            sorteo.idSorteo?.toString().includes(busqueda) ||
            sorteo.nomSorteo?.toLowerCase().includes(busqueda.toLowerCase())
        );
        setSorteosFiltrados(filtrados);
        setPaginaActual(1);
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idSorteo: '',
            nomSorteo: ''
        });
        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (sorteo) => {
        setFormulario({
            idSorteo: sorteo.idSorteo,
            nomSorteo: sorteo.nomSorteo
        });
        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
        setFormulario({
            idSorteo: '',
            nomSorteo: ''
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formulario.nomSorteo.trim()) {
            alert('El nombre del sorteo es requerido');
            return;
        }

        if (formulario.nomSorteo.length > 60) {
            alert('El nombre del sorteo no puede tener más de 60 caracteres');
            return;
        }

        try {
            if (modoEdicion) {
                await axios.put(`${API_URL}/${formulario.idSorteo}`, formulario);
                alert('Sorteo actualizado exitosamente');
            } else {
                await axios.post(API_URL, formulario);
                alert('Sorteo creado exitosamente');
            }
            cargarSorteos();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar el sorteo');
        }
    };

    const eliminar = async (id) => {
        if (window.confirm('¿Está seguro de eliminar este sorteo?')) {
            try {
                await axios.delete(`${API_URL}/${id}`);
                alert('Sorteo eliminado exitosamente');
                cargarSorteos();
            } catch (error) {
                console.error('Error al eliminar:', error);
                alert('Error al eliminar el sorteo');
            }
        }
    };

    const exportarExcel = () => {
        const datosExportar = sorteosFiltrados.map(sorteo => ({
            'ID': sorteo.idSorteo,
            'Nombre del Sorteo': sorteo.nomSorteo
        }));

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sorteos');
        XLSX.writeFile(workbook, 'sorteos.xlsx');
    };

    // Paginación
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const sorteosActuales = sorteosFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(sorteosFiltrados.length / itemsPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
    };

    const cambiarItemsPorPagina = (e) => {
        setItemsPorPagina(Number(e.target.value));
        setPaginaActual(1);
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Sorteos</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nuevo Sorteo
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre del Sorteo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sorteosActuales.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="sin-datos">No hay sorteos para mostrar</td>
                            </tr>
                        ) : (
                            sorteosActuales.map(sorteo => (
                                <tr key={sorteo.idSorteo}>
                                    <td>{sorteo.idSorteo}</td>
                                    <td>{sorteo.nomSorteo}</td>
                                    <td>
                                        <button
                                            onClick={() => abrirModalEditar(sorteo)}
                                            className="btn-accion"
                                            title="Editar"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            onClick={() => eliminar(sorteo.idSorteo)}
                                            className="btn-accion"
                                            title="Eliminar"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>
                        Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, sorteosFiltrados.length)} de {sorteosFiltrados.length} registros
                    </span>
                    <select
                        value={itemsPorPagina}
                        onChange={cambiarItemsPorPagina}
                        className="select-registros"
                    >
                        <option value={5}>5 por página</option>
                        <option value={10}>10 por página</option>
                        <option value={20}>20 por página</option>
                        <option value={50}>50 por página</option>
                    </select>
                </div>

                <div className="paginacion-controles">
                    <button
                        onClick={() => cambiarPagina(1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                        title="Primera página"
                    >
                        ⏮️
                    </button>
                    <button
                        onClick={() => cambiarPagina(paginaActual - 1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                    >
                        ◀️
                    </button>

                    {[...Array(totalPaginas)].map((_, index) => {
                        const numeroPagina = index + 1;
                        if (
                            numeroPagina === 1 ||
                            numeroPagina === totalPaginas ||
                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                        ) {
                            return (
                                <button
                                    key={numeroPagina}
                                    onClick={() => cambiarPagina(numeroPagina)}
                                    className={`btn-numero-pagina ${paginaActual === numeroPagina ? 'activo' : ''}`}
                                >
                                    {numeroPagina}
                                </button>
                            );
                        } else if (
                            numeroPagina === paginaActual - 2 ||
                            numeroPagina === paginaActual + 2
                        ) {
                            return <span key={numeroPagina}>...</span>;
                        }
                        return null;
                    })}

                    <button
                        onClick={() => cambiarPagina(paginaActual + 1)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                    >
                        ▶️
                    </button>
                    <button
                        onClick={() => cambiarPagina(totalPaginas)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                        title="Última página"
                    >
                        ⏭️
                    </button>
                </div>
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido">
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Sorteo' : 'Nuevo Sorteo'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Nombre del Sorteo *</label>
                                <input
                                    type="text"
                                    value={formulario.nomSorteo}
                                    onChange={(e) => setFormulario({ ...formulario, nomSorteo: e.target.value })}
                                    required
                                    maxLength={60}
                                    placeholder="Ingrese el nombre del sorteo"
                                />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-guardar">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default FSorteos;
